import React from 'react';

const Alert = (props) => {
    const { message } = props;

    const onClose = () => {
        props.callBack();
    };

    return (
        <div className={"dialog"} role="alert">
            {message}
            <hr style={{ border: "1px solid #CFCFCF" }} />
            <div style={{ textAlign:"center" }}>
                <button className="btn btn-secondary" onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default Alert;